import React, { Component } from "react";
import { Edit, PlusCircle, Trash2 } from "react-feather";

export default class Table extends Component {
  render() {
    const { changeMode, onSearch } = this.props;
    return (
      <div className="dashboard-wrapper">
        <h1 className="title font-weight-bold">Data Follow Up Pengobatan</h1>
        <div className="py-3">
          <div className="row">
            <div className="col-sm-8">
              <button
                className="btn btn-teal font-weight-bold"
                onClick={() => changeMode("add")}
              >
                <PlusCircle className="mr-2" />
                Tambah Data
              </button>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control bg-light"
                  placeholder="Cari berdasarkan nama"
                  onChange={(e) => onSearch(e)}
                />
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Aksi</th>
                  <th>Nama Puskesmas</th>
                  <th>Provinsi</th>
                  <th>Jumlah Kasuss</th>
                  <th>Sembuh</th>
                  <th>Meninggal</th>
                  <th>Tahun</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <button
                      className="btn btn-outline-primary btn-sm font-weight-bold mr-3"
                      onClick={() => onEdit(fup)}
                    >
                      <Edit size={15} /> Edit
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm font-weight-bold mr-3"
                      onClick={() => onRemove(fup.id)}
                    >
                      <Trash2 size={15} /> Hapus
                    </button>
                  </td>
                  <td>PKM Wanasaba</td>
                  <td>NTB</td>
                  <td>19.000</td>
                  <td>18.900</td>
                  <td>100</td>
                  <td>2021</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
